import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";
import header from './assets/images/header.png';
import header2 from './assets/images/header2.png';
import headerResult from './assets/images/header-result.png';
import importCss from './assets/images/import-css.png';
import importCss2 from './assets/images/import-css2.png';
import importImage from './assets/images/import-image.png';


const ReactLesson9 = () => {
  const [language, changeLanguage] = useState("react");
  const [lineNumbers, toggleLineNumbers] = useState(false);
    const code = (
      'text',
      `
      import React from 'react';

      const Header = () => {
        return(
          <div>
          <h1>This is Heading</h1>
          </div>
        )
      }

      export default Header;

      `
    );
    const code1 = (
      'text',
      `
      import React from 'react';
      import Header from './components/Header';

      const App = () => {
        return(
          <div>
          <Header />
          </div>
        );
      }

      export default App;

      `
    );
    const code2 = (
      'text',
      `
      import './style.scc'; //importing an SCC file
      

      `
    );
    const code3 = (
      'text',
      `
      import './style.css'; //importing an CSS file
      

      `
    );
    const code4 = (
      'text',
      `
      import logo from './logo.png';

      const App() {
        return {
          <div>
             {/*using the imported image */}
             <img src={logo} alt="Logo" />
             </div>
        };
      }
      

      `
    );


  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">


    <div className="alert alert-secondary" role="alert">
    <h3><strong>Importing Files</strong></h3>
      <p>You can import components created in separate files and use them within other components.</p>
      <p>We are going to create a file called <strong>Header.js</strong> in the components folder and import it in our <strong>App.js</strong></p>
      <h4 class="text-dark">Header.js</h4>
      <CopyBlock
                        language={"react"}
                        text={code} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      />      
                      
                      
                          <h4 class="text-dark">App.js</h4>
      <h4 class="text-dark">Result</h4>
      <CopyBlock
                        language={"react"}
                        text={code1} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      />          <h4 class="text-dark">Importing CSS/SCSS Files</h4>
      <p>To import CSS or SCSS files into your React components, use the <strong>import</strong> statement at the top of your JSX files.</p>
      <div>
      <img class="img-fluid mb-4" src={importCss} alt="react" />
      </div>
      <CopyBlock
                        language={"react"}
                        text={code3} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      />          <h4 class="text-dark">Importing Images</h4>
      <p>To import images in React, use the <strong>import</strong> statement to reference the image file's path. You can then use the imported image as a component or within the src attribute of an img tag.</p>
      <CopyBlock
                        language={"react"}
                        text={code4} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      />          <p>Remember to adjust the file paths based on your project's file structure when importing files in React.</p>
      <h3><strong>Summary</strong></h3>
      <p>Import statements are part of ES6 module syntax and are widely used in React applications to organize and use various resources across different parts of the application.</p>
  

  </div>
      </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}
export default ReactLesson9
  